<script setup>
import { Message, User, VideoCamera, List } from '@element-plus/icons-vue'
import { useChatStore } from '/src/stores/chat'

const chatStore = useChatStore()

const tabs = [
  { key: 'chats', label: '会话', icon: Message },
  { key: 'contacts', label: '联系人', icon: User },
  { key: 'meetings', label: '会议', icon: VideoCamera },
  { key: 'tasks', label: '任务', icon: List }
]

const handleTabClick = (key) => {
  chatStore.setActiveTab(key)
}
</script>

<template>
  <div class="chat-tabs">
    <div
      v-for="tab in tabs"
      :key="tab.key"
      class="chat-tab"
      :class="{ 'is-active': chatStore.activeTab === tab.key }"
      @click="handleTabClick(tab.key)"
    >
      <el-icon :size="18">
        <component :is="tab.icon" />
      </el-icon>
      <span class="tab-label">{{ tab.label }}</span>
    </div>
  </div>
</template>

<style scoped>
.chat-tabs {
  display: flex;
  background: white;
  border-bottom: 1px solid #e5e7eb;
}

.chat-tab {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  padding: 10px 8px;
  color: #6b7280;
  cursor: pointer;
  transition: all 0.2s ease;
  border-bottom: 2px solid transparent;
}

.chat-tab:hover {
  color: #0ea5e9;
  background: #f0f9ff;
}

.chat-tab.is-active {
  color: #0ea5e9;
  border-bottom-color: #0ea5e9;
}

.tab-label {
  font-size: 12px;
  font-weight: 500;
}
</style>
